
export const elementTypes = [
    { value: 0, label: 'Atrakcja' },
    { value: 1, label: 'Nocleg' },
    { value: 2, label: 'Transport indywidualny' },
    { value: 3, label: 'Transport zbiorowy' },
    { value: 4, label: 'Trekking' },
  ];

  
const defaultAttractionElement = {
    name : null,
    description : null,
    startDate : null,
    capacity : null,
    isWithLimitedPlaces: false,
    link : null,
    pricePerPerson : null
}

const defaultAccommodationElement = {
    name : null,
    description : null,
    startDate : null,
    isWithLimitedPlaces : false,
    capacity : null,
    buildingName : null,
    accommodationType : 1,
    accommodationBoard : null,
    link: null,
    pricePerPerson : null
}

const defaultIndividualTransport = {
    name : null,
    description : null,
    startDate : null,
    link : null
}

const defaultTransportElement = {
    name : null,
    description: null,
    startDate: null,
    isWithLimitedPlaces : false,
    capacity: null,
    link: null,
    pricePerPerson: null,
}
const defaultTrekkingElement = {
    name : null,
    description: null,
    startDate: null,
    isWithLimitedPlaces : false,
    capacity: null,
    difficulty: null,
    duration: null,
    distance: null,
    elevation: null,
    link: null,
}

export const defaultElements = [
    defaultAttractionElement,
    defaultAccommodationElement,
    defaultIndividualTransport,
    defaultTransportElement,
    defaultTrekkingElement


]


export const trekkingDifficultyLevels = [
    { value: 1, label: "Łatwa" },
    { value: 2, label: "Łatwa / średnia" },
    { value: 3, label: "Średnio wymagająca" },
    { value: 4, label: "Wymagająca" },
    { value: 5, label: "Bardzo trudna"},
  ];

  export const accommodationTypes = [
    { value: 1, label: "Inny obiekt" },
    { value: 2, label: "Schronisko" },
    { value: 3, label: "Hotel*" },
    { value: 4, label: "Hotel**" },
    { value: 5, label: "Hotel***" },
    { value: 6, label: "Hotel****" },
    { value: 7, label: "Hotel*****" },
    { value: 8, label: "Motel*" },
    { value: 9, label: "Motel**" },
    { value: 10, label: "Motel***" },
    { value: 11, label: "Motel****" },
    { value: 12, label: "Motel*****" },
    { value: 13, label: "Pensjonat*" },
    { value: 14, label: "Pensjonat**" },
    { value: 15, label: "Pensjonat***" },
    { value: 16, label: "Pensjonat****" },
    { value: 17, label: "Pensjonat*****" },
    { value: 18, label: "Kemping*" },
    { value: 19, label: "Kemping**" },
    { value: 20, label: "Kemping***" },
    { value: 21, label: "Kemping****" },
    { value: 22, label: "Kemping*****" },
    { value: 23, label: "Dom wycieczkowy I" },
    { value: 24, label: "Dom wycieczkowy II" },
    { value: 25, label: "Dom wycieczkowy III" },
    { value: 26, label: "Schronisko młodzieżowe I" },
    { value: 27, label: "Schronisko młodzieżowe II" },
    { value: 28, label: "Schronisko młodzieżowe III" }
  ]
  

